// strings.js

const strings = {
    STRIPE_DEV_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/test_14k3dfcNv7xD9CE14C", // depth 
    STRIPE_PROD_PRODUCT_PAYMENT_URL: "https://buy.stripe.com/aEU7tl4Jg5Fk6IM5kR", // depth

    STRIPE_SUBSCRIPTION_MANAGEMENT_URL: "https://billing.stripe.com/p/login/28ocP200L31J9gs7ss",
    SUBSCRIPTION_STATUS_API_URL: "https://funquiz.app/modular2/subscription-status",
    
    GENERIC_PAGE_TITLE: "Depth Gen AI 🎨",
    HOME_PAGE_TITLE: "Home - Depth Gen AI 🎨",
    DASHBOARD_PAGE_TITLE: "Home - Depth Gen AI 🎨",
    WELCOME_MESSAGE_H1_TITLE: "Welcome to Depth Gen AI 🎨",
    FX_DESCRIPTION_MESSAGE: "This f(x) can be used to generate images using depth structure of images, choose your image file, enter a prompt and then press the 'Submit Input' button below to get your result!",
    
    MAIN_API_NAME: "depth_gen_ai_1",
    MAIN_API_URL: "https://funquiz.app/modular2/depth-gen-ai-1",

    PROD_CLERK_PUB_KEY: "pk_live_Y2xlcmsueW9sbGVnLmNvbSQ",
    DEV_CLERK_PUB_KEY: "pk_test_aGFybWxlc3MtYmVlLTY5LmNsZXJrLmFjY291bnRzLmRldiQ",

    // ... add more strings as needed
};



export default strings;